import axios from 'axios';
import * as CONSTANTS from '../../constants/index';
import { getCustomValidationErrors, getCustomServerErrors } from '../../utils';
import { getConfig } from "../../reducers/portalConfig";
import { AXIOS_DEFAULT_OPTIONS } from '../';

export const resetAuthProviderEditStatuses = () => async (dispatch) => {
  dispatch({ type: CONSTANTS.RESET_AUTH_PROVIDERS_EDIT_STATUSES });
};

export const fetchAuthProvidersList = () => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/auth-providers`;
  dispatch({ type: CONSTANTS.FETCH_AUTH_PROVIDERS_LIST_REQUEST });
  await axios.get(url, AXIOS_DEFAULT_OPTIONS)
    .then(response => dispatch({
      type: CONSTANTS.FETCH_AUTH_PROVIDERS_LIST_SUCCESS,
      payload: response.data,
    }))
    .catch((error) => dispatch({
      type: CONSTANTS.FETCH_AUTH_PROVIDERS_LIST_ERROR, payload: getCustomServerErrors(error),
    }));
};

export const fetchAuthProvider = (authProviderUuid) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/auth-providers/${authProviderUuid}`;
    dispatch({ type: CONSTANTS.FETCH_AUTH_PROVIDER_REQUEST });
    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({ type: CONSTANTS.FETCH_AUTH_PROVIDER_SUCCESS, payload: response.data })
      })
      .catch((error) => {
        dispatch({
          type: CONSTANTS.FETCH_AUTH_PROVIDER_ERROR,
          payload: getCustomServerErrors(error),
        })
      })
  }
);

export const createAuthProvider = (payload) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/auth-providers`;
    dispatch({ type: CONSTANTS.CREATE_AUTH_PROVIDER_REQUEST });
    await axios.post(url, payload, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({ type: CONSTANTS.CREATE_AUTH_PROVIDER_SUCCESS, payload: response.data })
      })
      .catch((error) => {
        dispatch({
          type: CONSTANTS.CREATE_AUTH_PROVIDER_ERROR,
          payload: getCustomServerErrors(error),
        })
      })
  }
);

export const updateAuthProvider = (payload, authProviderUuid) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/auth-providers/${authProviderUuid}`;
    dispatch({ type: CONSTANTS.UPDATE_AUTH_PROVIDER_REQUEST });
    await axios.put(url, payload, AXIOS_DEFAULT_OPTIONS)
      .then(() => {
        dispatch({ type: CONSTANTS.UPDATE_AUTH_PROVIDER_SUCCESS, payload: CONSTANTS.SUCCESS })
      })
      .catch((error) => {
        dispatch({
          type: CONSTANTS.UPDATE_AUTH_PROVIDER_ERROR,
          payload: getCustomServerErrors(error),
        })
      })
  }
);

export const deleteAuthProvider = (authProviderUuid) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/auth-providers/${authProviderUuid}`;
    dispatch({ type: CONSTANTS.DELETE_AUTH_PROVIDER_REQUEST });
    await axios.delete(url, AXIOS_DEFAULT_OPTIONS)
      .then(() => {
        dispatch({ type: CONSTANTS.DELETE_AUTH_PROVIDER_SUCCESS, payload: CONSTANTS.SUCCESS })
      })
      .catch((error) => {
        dispatch({
          type: CONSTANTS.DELETE_AUTH_PROVIDER_ERROR,
          payload: getCustomServerErrors(error),
        })
      })
  }
);

// added for the sample client definitions associated with an auth provider
export const fetchClientDefinitions = (authProviderUuid) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/auth-providers/` +
      `${authProviderUuid}/client-definitions`;
    dispatch({ type: CONSTANTS.FETCH_ALL_SAMPLE_CLIENT_METADATA_REQUEST });
    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({
          type: CONSTANTS.FETCH_ALL_SAMPLE_CLIENT_METADATA_SUCCESS,
          payload: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: CONSTANTS.FETCH_ALL_SAMPLE_CLIENT_METADATA_ERROR,
          payload: getCustomServerErrors(error),
        })
      })
  }
);

export const createClientDefinition = (payload, authProviderUuid, skipValidation=false) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/auth-providers/` +
      `${authProviderUuid}/client-definitions?skipValidation=${skipValidation}`;
    dispatch({ type: CONSTANTS.CREATE_SAMPLE_CLIENT_METADATA_REQUEST });
    await axios.post(url, payload, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({ type: CONSTANTS.CREATE_SAMPLE_CLIENT_METADATA_SUCCESS, payload: response.data })
      })
      .catch((error) => {
        dispatch({
          type: CONSTANTS.CREATE_SAMPLE_CLIENT_METADATA_ERROR,
          payload: getCustomValidationErrors(error),
        })
      })
  }
);

export const updateClientDefinition = (
  payload, authProviderUuid, clientDefintionUuid, skipValidation=false,
) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/auth-providers/` +
      `${authProviderUuid}/client-definitions/${clientDefintionUuid}?skipValidation=${skipValidation}`;
    dispatch({ type: CONSTANTS.UPDATE_SAMPLE_CLIENT_METADATA_REQUEST });
    await axios.put(url, payload, AXIOS_DEFAULT_OPTIONS)
      .then(() => {
        dispatch({
          type: CONSTANTS.UPDATE_SAMPLE_CLIENT_METADATA_SUCCESS,
          payload: CONSTANTS.SUCCESS,
        })
      })
      .catch((error) => {
        dispatch({
          type: CONSTANTS.UPDATE_SAMPLE_CLIENT_METADATA_ERROR,
          payload: getCustomValidationErrors(error),
        })
      })
  }
);

export const deleteClientDefinition = (authProviderUuid, clientDefintionUuid) => (
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/0.1/auth-providers/` +
      `${authProviderUuid}/client-definitions/${clientDefintionUuid}`;
    dispatch({ type: CONSTANTS.DELETE_SAMPLE_CLIENT_METADATA_REQUEST });
    await axios.delete(url, AXIOS_DEFAULT_OPTIONS)
      .then(() => {
        dispatch({
          type: CONSTANTS.DELETE_SAMPLE_CLIENT_METADATA_SUCCESS,
          payload: CONSTANTS.SUCCESS,
        })
      })
      .catch((error) => {
        dispatch({
          type: CONSTANTS.DELETE_SAMPLE_CLIENT_METADATA_ERROR,
          payload: getCustomServerErrors(error),
        })
      })
  }
);

export const fetchWellKnownResponse = (authProviderUuid) => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/internal/auth-providers/` +
      `${authProviderUuid}/oidc-config`;
  dispatch({ type: CONSTANTS.FETCH_AUTH_PROVIDER_WELLKNOWN_REQUEST });
  await axios.get(url, AXIOS_DEFAULT_OPTIONS)
    .then(response => dispatch({
      type: CONSTANTS.FETCH_AUTH_PROVIDER_WELLKNOWN_SUCCESS,
      payload: response.data,
    }))
    .catch((error) => dispatch({
      type: CONSTANTS.FETCH_AUTH_PROVIDER_WELLKNOWN_ERROR, payload: getCustomServerErrors(error),
    }));
};

export const resetClientDefinitionEditStatuses = () => async (dispatch) => {
  dispatch({ type: CONSTANTS.CLEAR_CLIENT_METADATA_STATUSES });
};

export const resetAuthProvidersListStatus = () => (dispatch) => {
  dispatch({ type: CONSTANTS.RESET_AUTH_PROVIDERS_LIST_STATUS });
}
